import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=d9a3e072&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=d9a3e072&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a3e072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9a3e072')) {
      api.createRecord('d9a3e072', component.options)
    } else {
      api.reload('d9a3e072', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=d9a3e072&scoped=true", function () {
      api.rerender('d9a3e072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/healthManagement/feedback/detail.vue"
export default component.exports